import { Input, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0Account } from 'src/app/accounts/interfaces/accounts.types';

@Component({
  selector: 'app-mobile-footer',
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.scss'],
})
export class MobileFooterComponent {
  @Input() account: Auth0Account;

  dashboardUrl = '/dashboard';
  resultsUrl = '/results';
  addDataUrl = '/add-data';
  cartUrl = '/cart';

  constructor(private router: Router) {}

  isActive(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
